<template>
  <div id="xdc">
    <el-row>
      <el-col :span="8">
        <div id="pie1" style="height: 370px;"></div>
      </el-col>
      <el-col :span="8">
        <div id="pie2" style="height: 370px;"></div>
      </el-col>
      <el-col :span="8">
        <div id="pie3" style="height: 370px;"></div>
      </el-col>
    </el-row>
    <div style="width: 100%;margin-top: 10px;">
      <el-table :data="tableData" border height="450px">
        <el-table-column prop="eleCode" label="序号"></el-table-column>
        <el-table-column prop="DeviceName" label="设备类"></el-table-column>
        <el-table-column prop="code" label="设备"></el-table-column>
        <el-table-column prop="address" label="事件名称"></el-table-column>
        <el-table-column prop="fff" label="报警等级"></el-table-column>
        <el-table-column prop="warn" label="报警值"></el-table-column>
        <el-table-column prop="date" label="报警时间"></el-table-column>
        <el-table-column prop="nextdate" label="确认时间"></el-table-column>
        <el-table-column prop="sdate" label="解除时间"></el-table-column>
        <el-table-column prop="ccc" label="报警状态"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import * as echarts from '../../../public/static/echart/echarts';
  export default {
    data() {
      return {
        pieChart1: null,
        pieChart2: null,
        pieChart3: null,
        tableData: [{
          eleCode: '1',
          DeviceName: '温湿度',
          code: '1#温湿度',
          address: '温度超高报警',
          fff: '一般报警',
		  warn: '30.12',
		  date: '2020-07-30 16:23:00',
          nextdate: '2020-07-30 16:23:00',
		  sdate: '2020-07-30 16:23:00',
          ccc: '已解除已确认'
        }, {
		  eleCode: '2',
          DeviceName: '温湿度',
          code: '2#温湿度',
          address: '湿度超高报警',
          fff: '重要报警',
		  warn: '70.45',
		  date: '2020-08-10 14:15:11',
          nextdate: '2020-08-10 14:15:11',
		  sdate: '2020-08-10 14:15:11',
          ccc: '已解除已确认'
        }, {
		  eleCode: '2',
          DeviceName: '温湿度',
          code: '2#温湿度',
          address: '湿度超高报警',
          fff: '重要报警',
		  warn: '70.45',
		  date: '2020-08-15 10:02:40',
          nextdate: '2020-08-15 10:02:40',
		  sdate: '2020-08-15 10:02:40',
          ccc: '已解除已确认'
        }, {
		  eleCode: '1',
          DeviceName: '温湿度',
          code: '1#温湿度',
          address: '温度超高报警',
          fff: '一般报警',
		  warn: '30.12',
		  date: '2020-09-01 08:45:10',
          nextdate: '2020-09-01 08:45:10',
		  sdate: '2020-09-01 08:45:10',
          ccc: '已解除已确认'
        }]
      }
    },
    methods: {
      initChart() {
		var _this = this;
        this.pieChart1 = echarts.init(document.getElementById('pie1'));
        this.pieChart2 = echarts.init(document.getElementById('pie2'));
        this.pieChart3 = echarts.init(document.getElementById('pie3'));
        var option = {
          tooltip: {
            formatter: '{a} <br/>{c} {b}'
          },
          series: [{
            name: '电池总电压',
            type: 'gauge',
            min: 0,
            max: 1000,
            splitNumber: 10,
            radius: '90%',
            axisLine: { // 坐标轴线
              lineStyle: { // 属性lineStyle控制线条样式
                color: [
                  [0.09, 'lime'],
                  [0.82, '#1e90ff'],
                  [1, '#ff4500']
                ],
                width: 3,
                shadowColor: '#fff', //默认透明
                shadowBlur: 10
              }
            },
            axisLabel: { // 坐标轴小标记
              fontWeight: 'bolder',
              color: '#fff',
              shadowColor: '#fff', //默认透明
              shadowBlur: 10
            },
            axisTick: { // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: { // 属性lineStyle控制线条样式
                color: 'auto',
                shadowColor: '#fff', //默认透明
                shadowBlur: 10
              }
            },
            splitLine: { // 分隔线
              length: 25, // 属性length控制线长
              lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: '#fff',
                shadowColor: '#fff', //默认透明
                shadowBlur: 10
              }
            },
            pointer: { // 分隔线
              shadowColor: '#fff', //默认透明
              shadowBlur: 5
            },
            title: {
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: 'bolder',
                fontSize: 20,
                fontStyle: 'italic',
                color: '#fff',
                shadowColor: '#fff', //默认透明
                shadowBlur: 10
              }
            },
            detail: {
              backgroundColor: 'rgba(30,144,255,0.8)',
              borderWidth: 1,
            //   borderColor: '#fff',
              shadowColor: '#fff', //默认透明
              shadowBlur: 5,
              offsetCenter: [0, '50%'], // x, y，单位px
              textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: 'bolder',
                color: '#fff'
              }
            },
            data: [{
              value: 40.16,
              name: '电压(V)'
            }]
          }, ]
        };
        this.pieChart1.setOption(option, true);
        this.pieChart2.setOption(option, true);
        this.pieChart3.setOption(option, true);
				window.addEventListener("resize", function(){
					_this.pieChart1.resize();
					_this.pieChart2.resize();
					_this.pieChart3.resize();
				});
      },
    },
    mounted() {
      this.initChart();
    }
  }

</script>
<style scoped>
  #pie1, #pie2, #pie3{
	background: none;
	border: 1px solid #425da7;
  }
  #pie1:hover, #pie2:hover, #pie3:hover{
    box-shadow: #3c4877 3px 4px 9px 4px;
  }
</style>